import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import Image from '../image';
import RichText from 'components/rich-text';
import Icon from 'components/icon';
import cn from 'classnames';

const SolarisBanner = ({ image, imageText, title, text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);
  const hasImage = image && image.src;

  useEffect(() => {
    const updateHeight = () => {
      if (contentRef.current) {
        const content = contentRef.current;
        setHeight(isOpen ? content.getBoundingClientRect().height : 0);
      }
    };

    updateHeight();

    if (isOpen) {
      window.addEventListener('resize', updateHeight);
    } else {
      window.removeEventListener('resize', updateHeight);
    }

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [isOpen]);

  const handleToggle = event => {
    event.preventDefault();
    setIsOpen(!isOpen);
  };

  const ariaControl = 'solaris-banner-content';
  const ariaLabelledby = 'solaris-banner-title';

  return (
    <div
      className={cn('solaris-banner', {
        'solaris-banner--expanded': isOpen,
        'solaris-banner--has-image': hasImage
      })}
    >
      <button
        className="solaris-banner-toggle"
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-controls={ariaControl}
        id={ariaLabelledby}
      >
        <span>{title}</span>
        <Icon className="solaris-banner-icon" name="small-arrow-down" />
      </button>

      <div
        id={ariaControl}
        className="solaris-banner-expandable-content"
        style={{ maxHeight: `${height}px` }}
        role="region"
        aria-labelledby={ariaLabelledby}
      >
        <div className="solaris-banner-content" ref={contentRef}>
          {image && (
            <div className="solaris-logo-block">
              <Image {...image} />
              <span>{imageText}</span>
            </div>
          )}
          <div className="solaris-text-block">
            <div className="solaris-text-block-content">
              <RichText text={text} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SolarisBanner.propTypes = {
  image: PropTypes.exact(Image.propTypes),
  imageText: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string
};

export default SolarisBanner;
